<template>
  <el-dialog
    custom-class="import-dialog"
    :title="title"
    :visible="visible"
    width="800px"
    @close="close"
  >
    <el-steps :active="1" simple>
      <el-step title="下载数据模板" icon="hmicon icon-yi"></el-step>
      <el-step title="导入数据" icon="hmicon icon-ziyuan"></el-step>
      <el-step title="导入成功" icon="hmicon icon-san"></el-step>
    </el-steps>
    <div class="import-dialog-body">
      <div class="mb20">
        <div class="title">下载数据模板</div>
        <div class="tips">必须严格按照模板内容填写，否则可能会出现导入异常</div>
        <div class="tips">不要随意增删表格字段，以免出现导入异常</div>
        <div class="tips" v-if="filterText === 'memberMobile'">
          导入手机号会进行验证，会过滤重复和有误的手机号，请务必保证手机号严谨性
        </div>
      </div>
      <div class="mb20">
        <el-button
          @click="outPutTemp"
          type="primary"
          size="small"
          icon="hmicon icon-xls"
          >模板下载</el-button
        >
      </div>
      <div>
        <div class="title">导入填写好的资料</div>
        <div class="flex" ref="select_frame">
          <div class="import-btn open-file">
            <div class="add-wrapper">
              <span class="hmicon icon-hao pointer"></span>
            </div>
            <span>点击导入</span>
            <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="flex flex-column flex-end">
            <!-- <div class="tips">点击或将文件拖拽到这里导入</div> -->
            <div v-if="fileName">已上传{{ fileName }}</div>
            <div>文件后缀名必须为xls,xlsx,及csv，文件大小不得大于3M</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import XLSX from "xlsx";
import { arrayUnique2 } from "@/utils/utils";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  props: {
    tHeader: {
      type: Array,
      default: () => []
    },
    tBody: {
      type: Array,
      default: () => []
    },
    filterText: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      fileName: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    outPutTemp() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(
          this.tHeader,
          [[]],
          this.title + new Date().toLocaleString()
        );
      });
    },
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      this.fileName = f.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        if (this.filterText === "memberMobile") {
          result.forEach(v => {
            if (/^1[3-9]\d{9}$/.test(v[1])) {
              formatResult.push({
                memberName: v[0] + "",
                memberMobile: v[1] + ""
              });
            }
          });
        } else {
          result.map((v, i) => {
            formatResult.push({});

            this.tBody.map((o, index) => {
              formatResult[i][this.tBody[index]] = v[index];
            });
          });
        }

        formatResult = arrayUnique2(formatResult, this.filterText);

        this.$emit("importSuccess", formatResult);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.import-dialog-body {
  padding: 40px 20px;
}
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin: 0 auto 10px;
  cursor: pointer;
  .hmicon {
    font-size: 14px;
  }
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #222;
  margin-bottom: 20px;
}

.import-btn {
  border: 1px solid #ddd;
  text-align: center;
  padding: 28px;
  margin-right: 10px;
  cursor: pointer;
}

.tips {
  color: #666;
  line-height: 20px;
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
</style>
